// src/admin/components/ResetPasswordModal.js
import React, { useState } from 'react';
// import { generatePassword, copyToClipboard } from '../../utils/helpers';
import './ResetPasswordModal.css';
import { generatePassword, copyToClipboard } from '../utils/helpers';

const ResetPasswordModal = ({ user, onSubmit, onClose }) => {
  const [password, setPassword] = useState(generatePassword(12));
  const [showPassword, setShowPassword] = useState(true);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleGenerate = () => {
    setPassword(generatePassword(12));
    setShowPassword(true);
    setCopied(false);
  };

  const handleCopy = async () => {
    const result = await copyToClipboard(password, 'Password');
    if (result.success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleSubmit = async () => {
    if (!password || password.length < 8) {
      return;
    }

    try {
      setLoading(true);
      await onSubmit(password);
    } catch (err) {
      console.error('Failed to reset password:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-container modal-sm p-4" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            <i className="bi bi-key"></i>
            Reset Password
          </h2>
          <button className="close-btn" onClick={onClose}>
            <i className="bi bi-x"></i>
          </button>
        </div>

        <div className="reset-password-content">
          <div className="user-info-banner">
            <div className="user-avatar-large">
              {user.name.charAt(0).toUpperCase()}
            </div>
            <div>
              <h3>{user.name}</h3>
              <p>{user.email}</p>
            </div>
          </div>

          <div className="password-section">
            <label htmlFor="new-password">New Password</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                id="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="password-input"
                placeholder="Enter new password"
              />
              <button
                type="button"
                className="icon-btn-inline"
                onClick={() => setShowPassword(!showPassword)}
                title={showPassword ? 'Hide password' : 'Show password'}
              >
                <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
              </button>
              <button
                type="button"
                className="icon-btn-inline"
                onClick={handleCopy}
                title="Copy password"
              >
                <i className={`bi ${copied ? 'bi-check2' : 'bi-clipboard'}`}></i>
              </button>
            </div>

            {password.length < 8 && (
              <span className="error-message">
                <i className="bi bi-exclamation-circle"></i>
                Password must be at least 8 characters
              </span>
            )}
          </div>

          <button
            type="button"
            className="btn-generate"
            onClick={handleGenerate}
          >
            <i className="bi bi-arrow-repeat"></i>
            Generate New Password
          </button>

          <div className="info-box">
            <i className="bi bi-info-circle"></i>
            <div>
              <strong>Important:</strong>
              <p>Make sure to copy and securely share this password with the user. They won't be able to recover it later.</p>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={handleSubmit}
            disabled={loading || password.length < 8}
          >
            {loading ? (
              <>
                <span className="spinner-small"></span>
                Resetting...
              </>
            ) : (
              <>
                <i className="bi bi-check-circle"></i>
                Reset Password
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordModal;